@use '@/styles/tokens' as *;

// Figma Toast (node 193-3750). Light bg comes from the Notification theme
// token (surface.page); dark appearance overrides it here.

.toast {
  border-radius: 16px;
  box-shadow: var(--shadow-overlay);

  .title,
  .description {
    word-break: break-word;
  }
}

.title {
  font-size: 14px;
  font-weight: var(--font-weight-medium);
  color: var(--text-primary);
}

.title.success {
  color: $color-brand-400;
}

.title.warning {
  color: $color-warning-700;
}

.title.error {
  color: $color-error-700;
}

.description {
  font-size: 13px;
  color: var(--text-muted);
}

.icon {
  color: var(--text-primary);
}

.icon.success {
  color: $color-brand-400;
}

.icon.warning {
  color: $color-warning-700;
}

.icon.error {
  color: $color-error-700;
}

.dark {
  background: $color-neutral-950 !important;

  .title {
    color: var(--text-inverse);
  }

  .title.success {
    color: $color-brand-400;
  }

  .title.warning {
    color: $color-warning-700;
  }

  .title.error {
    color: $color-error-700;
  }

  .description {
    color: var(--text-disabled);
  }

  .icon {
    color: var(--text-inverse);
  }

  .icon.success {
    color: $color-brand-400;
  }

  .icon.warning {
    color: $color-warning-700;
  }
  .icon.error {
    color: $color-error-700;
  }
}

:global {
  .ant-notification {
    .ant-notification-notice {
      width: fit-content;
    }

    // Figma Toast (node 1:265757) is a 38px pill: 10px/16px padding, a 16px icon
    // 10px from an 18px text line. antd instead lays the notice out as a
    // top-aligned flex row with a 12px gap and the icon on `line-height: 1`
    // beside a 24px title line box, which leaves the icon riding above the text
    // and the pill 2px too tall. Pin both to the same 18px line.
    .ant-notification-notice-wrapper {
      gap: 10px;
    }

    .ant-notification-notice-title {
      line-height: 18px;
    }

    .ant-notification-notice-icon {
      display: flex;
      align-items: center;
      height: 18px;
    }
  }
}
